// src/hooks/usePageContent.js
import { useState } from "react";
import {
  getAddressByUser,
  createAddress,
  editAddress,
  deleteAddress,
  getSingleAddress,
  setPrimaryAddress
} from "../services/addressService";

const useAddress = () => {
  const [status, setStatus] = useState("idle"); // idle | loading | done | error
  const [addStatus, setAddStatus] = useState("idle");
  const [removeStatus, setRemoveStatus] = useState("idle");
  const [setPrimaryStatus, setSetPrimaryStatus] = useState("idle");
  const [error, setError] = useState("");
  const [data, setData] = useState([]);
  const [single, setSingle] = useState(null);

  const fetchAddress = async (userId) => {
    setStatus("loading");
    setError("");

    try {
      const response = await getAddressByUser(userId);

      if (response?.status !== "Error") {
        setData(response.data ?? response); // depending on API shape
        setStatus("done");
      } else {
        setStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };

  const fetchSingleAddress = async (userId) => {
    setStatus("loading");
    setError("");

    try {
      const response = await getSingleAddress(userId);

      if (response?.status !== "Error") {
        setSingle(response.data ?? response); // depending on API shape
        setStatus("done");
      } else {
        setStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };

  const addAddress = async (address) => {
    setAddStatus("loading");
    setError("");
    // cart item
    // "productId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    // "variantCombinationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    // "applicationUserId": "string",
    // "qty": 0
    try {
      const response = await createAddress(address);

      if (response?.status !== "Error") {
        setAddStatus("done");
      } else {
        setAddStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setAddStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };

  const updateAddress = async (address) => {
    setAddStatus("loading");
    setError("");
    // cart item
    // "productId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    // "variantCombinationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    // "applicationUserId": "string",
    // "qty": 0
    try {
      const response = await editAddress(address);

      if (response?.status !== "Error") {
        setAddStatus("done");
      } else {
        setAddStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setAddStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };

  const removeAddress = async (addressId) => {
    setRemoveStatus("loading");
    setError("");
    try {
      const response = await deleteAddress(addressId);

      if (response?.status !== "Error") {
        setRemoveStatus("done");
      } else {
        setRemoveStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setRemoveStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };

    const setPrimary = async (addressId) => {
    setSetPrimaryStatus("loading");
    setError("");
    // cart item
    // "productId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    // "variantCombinationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    // "applicationUserId": "string",
    // "qty": 0
    try {
      const response = await setPrimaryAddress(addressId);

      if (response?.status !== "Error") {
        setSetPrimaryStatus("done");
      } else {
        setSetPrimaryStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setSetPrimaryStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };


  const resetStatus = () => {
    setStatus("idle");
    setAddStatus("idle");
    setRemoveStatus("idle");
    setSetPrimaryStatus("idle");
    setError("");
  };

  return {
    fetchAddress,
    fetchSingleAddress,
    addAddress,
    updateAddress,
    removeAddress,
    setPrimary,
    data,
    single,
    status,
    addStatus,
    removeStatus,
    setPrimaryStatus,
    error,
    resetStatus,
  };
};

export default useAddress;
